<template>
  <v-data-iterator
    :items="datas"
    item-key="id"
    :items-per-page="10"
    :search="search"
  >
    <template v-slot:header>
      <v-text-field
          v-model="search"
          clearable
          label="Search"
      />
    </template>
    <template v-slot:default="props">
      <v-row
        v-for="item in props.items"
        :key="item.id"
      >
        <v-col xs="6" class="selectColumn">
          <v-text-field
            readonly
            single-line
            :value="item.name"
          ></v-text-field>
        </v-col>
        <v-col xs="6"  class="selectColumn">
          <v-autocomplete
              :items="selects"
              v-model="item.reportingId"
              clearable
              label="Mapping"
            ></v-autocomplete>
        </v-col>
      </v-row>
    </template>




  </v-data-iterator>
  
  
</template>

<script>
  export default {
    props : ['selects', 'datas', 'type'],
    data: () => ({
     search: ""
    }),
  }
</script>

<style scoped>
  .selectColumn {
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>